import React from 'react';

export default function StarRating({ rating }) {
  const untilIndex = parseInt(rating, 10);
  const stars      = [ 1, 2, 3, 4, 5 ].map(value => (<Star key={value} fill={value <= untilIndex}/>));

  return <div className="star-rating">{stars}</div>;
}


function Star({ fill }) {
  const icon = fill ? 'star_fill' : 'star';
  return <i className="star-rating__icon f7-icons">{icon}</i>;
}
